/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExtrasPartsAnyOf } from './extrasPartsAnyOf';

export type ExtrasParts = ExtrasPartsAnyOf | null;
